import { Box } from "@mui/material"
import type { FC } from "react"
import { useMemo } from "react"

import { GoodsReceiptDetailsSubtotals, GoodsReceiptPurchaseOrderPanel } from "../../../../components"
import type { GoodsReceiptTotals } from "../../../../types"
import { calculatePurchaseOrderTotalsFromPalletRows } from "../../../../utils"

import { StoredPurchaseOrderLine } from "./StoredPurchaseOrderLine"

import type { GoodsReceiptPalletRow, GoodsReceiptProductDetail, Order } from "@/graphql/codegen/graphql"

interface StoredPurchaseOrderProps {
  purchaseOrder: Order
  goodsReceiptLines: GoodsReceiptProductDetail[]
  goodsReceiptPalletRows: GoodsReceiptPalletRow[]
}

export const StoredPurchaseOrder: FC<StoredPurchaseOrderProps> = ({
  purchaseOrder,
  goodsReceiptLines,
  goodsReceiptPalletRows,
}) => {
  const totals: GoodsReceiptTotals = useMemo(() => {
    const lines = purchaseOrder.orderLines ?? []

    return calculatePurchaseOrderTotalsFromPalletRows(lines, goodsReceiptLines, goodsReceiptPalletRows)
  }, [purchaseOrder.orderLines, goodsReceiptLines, goodsReceiptPalletRows])

  return (
    <GoodsReceiptPurchaseOrderPanel
      key={purchaseOrder.orderId}
      purchaseOrder={purchaseOrder}
      totals={totals}
      hasEstimatedValues={false}
    >
      <Box className='flex flex-col gap-y-6'>
        {purchaseOrder.orderLines?.map((purchaseOrderLine) => (
          <StoredPurchaseOrderLine
            key={purchaseOrderLine.orderLineId}
            purchaseOrderLine={purchaseOrderLine}
            goodsReceiptLines={goodsReceiptLines}
            goodsReceiptPalletRows={goodsReceiptPalletRows}
          />
        ))}
        <GoodsReceiptDetailsSubtotals label='Subtotal Received' totals={totals} />
      </Box>
    </GoodsReceiptPurchaseOrderPanel>
  )
}
